<template>
    <activix-tooltip :content="disabled ? '' : tooltipContent" :placement="tooltipPlacement">
        <button
            data-test="composer-button"
            class="flex justify-center items-center relative flex-1 flex-no-wrap p-3 rounded"
            :class="buttonClasses"
            @click.prevent="handleClick"
        >
            <icon :name="icon" data-test="composer-button-icon" />
            <slot />
            <template v-if="dropdown">
                <icon
                    data-test="composer-button-dropdown-icon"
                    class="ml-1.5 -mr-1 text-2xs text-gray-600 transform | transition-all duration-200"
                    :class="dropdownOpened ? '-rotate-180' : 'rotate-0'"
                    name="bold/arrow-down-1"
                />
            </template>
        </button>
    </activix-tooltip>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export const colors: string[] = ['gray', 'light-gray'];

    export default defineComponent({
        name: 'ComposerButton',

        emits: ['click'],

        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            icon: {
                type: String,
                default: '',
            },
            tooltipContent: {
                type: String,
                default: '',
            },
            tooltipPlacement: {
                type: String,
                default: 'top',
            },
            dropdown: {
                type: Boolean,
                default: false,
            },
            dropdownOpened: {
                type: Boolean,
                default: false,
            },
            selected: {
                type: Boolean,
                default: false,
            },
            color: {
                type: String,
                default: 'gray',
                validator: (value: string): boolean => colors.includes(value),
            },
        },

        computed: {
            buttonClasses(): string {
                if (this.disabled) {
                    return 'bg-gray-100 text-gray-500 cursor-not-allowed';
                }

                if (this.selected) {
                    return 'shadow-md bg-white | hover:bg-gray-100';
                }

                if (this.color === 'light-gray') {
                    return 'bg-gray-150 | hover:bg-gray-300';
                }

                return 'bg-gray-300 | hover:bg-gray-400';
            },
        },

        methods: {
            handleClick(): void {
                if (!this.disabled) {
                    this.$emit('click');
                }
            },
        },
    });
</script>
